import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "../lib/api";
import Reveal from "../components/Reveal";
import { Clock, ArrowRight, Loader2 } from "lucide-react";

export default function Services() {
  const [services, setServices] = useState(null);

  useEffect(() => {
    api.get("/services").then((r) => setServices(r.data)).catch(() => setServices([]));
  }, []);

  const categories = services
    ? [...new Set(services.map((s) => s.category))]
    : [];

  return (
    <div data-testid="services-page" className="pt-32 pb-24 max-w-7xl mx-auto px-5 sm:px-8 min-h-screen">
      <Reveal>
        <div className="label-caps mb-3">Price List</div>
        <h1 className="font-display text-6xl sm:text-7xl tracking-tighter mb-4">Our Services</h1>
        <p className="text-gray-400 max-w-xl text-lg">
          Honest pricing, master craftsmanship. Every service includes a consultation
          so you leave looking exactly how you imagined.
        </p>
      </Reveal>

      {services === null ? (
        <div className="flex justify-center py-24">
          <Loader2 className="w-8 h-8 text-[#D4AF37] animate-spin" />
        </div>
      ) : (
        <div className="mt-16 space-y-16">
          {categories.map((cat) => (
            <div key={cat}>
              <h2 className="font-display text-3xl text-[#D4AF37] mb-6 border-b border-white/10 pb-3">{cat}</h2>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
                {services.filter((s) => s.category === cat).map((s, i) => (
                  <Reveal key={s.id} delay={i * 0.05}>
                    <div
                      data-testid={`service-card-${s.id}`}
                      className="group bg-[#141414] border border-white/5 rounded-2xl p-7 flex items-center justify-between hover:-translate-y-1 hover:border-[#D4AF37]/30 transition-all duration-300"
                    >
                      <div>
                        <h3 className="text-xl font-medium">{s.name}</h3>
                        <p className="text-gray-400 text-sm mt-1 max-w-sm">{s.description}</p>
                        <div className="flex items-center gap-2 mt-3 text-xs text-gray-500">
                          <Clock className="w-3.5 h-3.5" /> {s.duration} min
                        </div>
                      </div>
                      <div className="text-right ml-4 shrink-0">
                        <div className="font-display text-3xl text-[#D4AF37]">£{s.price}</div>
                        <Link to="/book" className="text-xs text-gray-400 hover:text-white flex items-center gap-1 mt-2 justify-end">
                          Book <ArrowRight className="w-3 h-3" />
                        </Link>
                      </div>
                    </div>
                  </Reveal>
                ))}
              </div>
            </div>
          ))}
        </div>
      )}

      <Reveal>
        <div className="mt-20 text-center">
          <Link to="/book" className="px-10 py-4 rounded-full bg-[#D4AF37] text-black font-medium inline-flex items-center gap-2 hover:bg-[#F3E5AB] transition-colors duration-300">
            Book Your Appointment <ArrowRight className="w-4 h-4" />
          </Link>
        </div>
      </Reveal>
    </div>
  );
}
